import React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
function HeaderBrand(_ref) {
  let {
    onClick,
    className,
    children: brand,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(brand.type, {
    className: clsx(className, 'header-brand'),
    ...brand.props,
    ...rest,
    ...(onClick && {
      onClick: e => {
        onClick(e, {
          ...brand.props,
          linkContext: 'HeaderHome'
        });
        return true;
      }
    })
  });
}
export default HeaderBrand;